// src/components/select/select.styles.ts
import { tv } from "tailwind-variants";
var selectStyles = tv({
  slots: {
    container: "relative flex flex-col gap-2 w-full",
    selectWrapper: "flex gap-3 justify-center items-center bg-neutral-0 border border-neutral-200 rounded cursor-pointer focus:border-secondary overflow-hidden w-full outline-none transition",
    selectLabel: "font-semibold text-lg pointer-events-none text-left w-full",
    selectInner: "relative flex items-center w-full",
    select: "outline-none w-full text-left truncate",
    selectContainer: "flex flex-col bg-main border border-neutral-20 rounded-2xl z-10 max-h-48 overflow-auto",
    selectList: "list-none m-0 p-2 relative outline-none",
    selectItem: "flex justify-start items-center whitespace-nowrap p-3 cursor-pointer hover:bg-neutral-10 transition-colors",
    error: "text-primary-700 text-xs",
    startContent: "h-4 w-4 text-neutral-600 has-[svg]:fill-neutral-600 overflow-hidden motion-safe:transition-transform",
    endContent: "h-4 w-4 text-neutral-600 has-[svg]:fill-neutral-600 overflow-hidden motion-safe:transition-transform"
  },
  variants: {
    isOpen: {
      true: {
        selectWrapper: "border-secondary",
        endContent: "transform rotate-180"
      },
      false: {
        selectWrapper: "hover:border-neutral-500 "
      }
    },
    size: {
      sm: {
        select: "py-1",
        selectWrapper: "px-4 h-10"
      },
      md: {
        select: "py-2",
        selectWrapper: "px-6 h-12"
      },
      lg: {
        select: "py-3",
        selectWrapper: "px-8 h-14"
      }
    },
    isInvalid: {
      true: {
        selectWrapper: "!border-primary-700"
      }
    },
    highlighted: {
      true: {
        selectItem: "bg-neutral-10"
      }
    },
    disabled: {
      true: {
        selectWrapper: "cursor-not-allowed bg-neutral-300 border-neutral-300",
        select: "cursor-not-allowed"
      }
    },
    placeholder: {
      true: {
        select: "text-neutral-600"
      }
    }
  },
  compoundSlots: [
    {
      slots: ["startContent", "endContent"],
      size: ["sm", "md", "lg"],
      className: "[&>svg]:w-4 [&>svg]:h-4"
    }
  ]
});
export {
  selectStyles
};
